module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "couponProfile"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "searchBox"
  }, [_c('div', {
    staticClass: "back"
  }, [_c('button', {
    staticClass: "back-arrow",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'addcoupon'
        })
      }
    }
  }, [_vm._v("返回")])]), _vm._v(" "), _c('div', {
    staticClass: "coupon-info"
  }, [_c('div', {
    staticClass: "couopon-name info-item"
  }, [_vm._v("优惠券名称：" + _vm._s(_vm.$route.query.couponName))]), _vm._v(" "), _c('div', {
    staticClass: "create-name info-item"
  }, [_vm._v("创建人：" + _vm._s(_vm.$route.query.createName))]), _vm._v(" "), _c('div', {
    staticClass: "couopon-desc info-item",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', [(_vm.$route.query.startTime && _vm.$route.query.endTime && !_vm.$route.query.expireDay) ? _c('span', {
    staticClass: "time"
  }, [_vm._v("有效时间："), _c('i', [_vm._v(_vm._s(_vm._f("numberToDate")(_vm.$route.query.startTime, '')))]), _vm._v("至"), _c('i', [_vm._v(_vm._s(_vm._f("numberToDate")(_vm.$route.query.endTime, '')))])]) : _c('span', {
    staticClass: "time"
  }, [_vm._v("有效天数："), _c('i', [_vm._v(_vm._s(_vm.$route.query.expireDay) + "天")])]), _vm._v(" "), _c('span', {
    staticClass: "gift"
  }, [_vm._v(" 已派发：" + _vm._s(_vm.$route.query.sendCount) + "张")]), _vm._v(" "), _c('span', {
    staticClass: "gift"
  }, [_vm._v(" 已使用：" + _vm._s(_vm.$route.query.useCount) + "张")])]), _vm._v(" "), _c('div', {
    staticClass: "stop"
  }, [(_vm.$route.query.statusType != 'STOP' && _vm.$route.query.statusType != 'EXPIRED') ? _c('button', {
    on: {
      "click": _vm.stop
    }
  }, [_vm._v("停用")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-change"
  }, [_c('span', {
    staticClass: "tab-item",
    class: {
      active: _vm.filterStatus == 'NORMAL'
    },
    on: {
      "click": function($event) {
        return _vm.filterCoupon('NORMAL')
      }
    }
  }, [_vm._v("已派发优惠券")]), _vm._v(" "), _c('span', {
    staticClass: "tab-item",
    class: {
      active: _vm.filterStatus == 'STOP'
    },
    on: {
      "click": function($event) {
        return _vm.filterCoupon('STOP')
      }
    }
  }, [_vm._v("已作废优惠券")])]), _vm._v(" "), _c('div', {
    staticClass: "coupon-filter"
  }, [_c('div', {
    staticClass: "search-wrap"
  }, [_c('span', [_vm._v("会员搜索：")]), _vm._v(" "), _c('div', {
    staticClass: "search",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入会员手机号码."
    },
    model: {
      value: (_vm.searchPhone),
      callback: function($$v) {
        _vm.searchPhone = $$v
      },
      expression: "searchPhone"
    }
  }), _vm._v(" "), (_vm.searchData.length > 0) ? _c('div', {
    staticClass: "vip-list-wrap"
  }, [_c('div', {
    staticClass: "vip-list"
  }, [_c('ul', _vm._l((_vm.searchData), function(item, index) {
    return _c('li', {
      key: index,
      class: _vm.nowVipIndex == index ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.setNowSearchVip(item)
        },
        "mouseenter": function($event) {
          _vm.nowVipIndex = index
        }
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "phone-num right"
    }, [_vm._v(_vm._s(item.mobile))])])
  }), 0)])]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('table', {
    staticClass: "conTable",
    class: {
      overLengthTable: _vm.couponList.length > _vm.pageSize
    }
  }, _vm._l((_vm.couponList), function(item, ind) {
    return _c('tr', {
      staticClass: "listTr"
    }, [_c('td', {
      staticClass: "wrap",
      staticStyle: {
        "width": "15%"
      }
    }, [_c('el-tooltip', {
      key: item.id,
      attrs: {
        "effect": "dark",
        "disabled": !item.id,
        "content": _vm.$route.query.goodsName,
        "placement": "top"
      }
    }, [(item.id) ? _c('span', {
      staticClass: "overflowText"
    }, [_vm._v(_vm._s(_vm.$route.query.goodsName))]) : _vm._e()])], 1), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "12%"
      }
    }, [_vm._v(_vm._s(item.memberName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.mobile))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(item.creatorName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("numberToDate")(item.addTime, '')))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, [(item.id) ? [_c('span', [_vm._v(_vm._s(_vm._f("dateForGradePage")(item.endTime)))])] : _vm._e()], 2), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm.stautsOprions[item.stauts]))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "10%"
      }
    }, [(item.id) ? _c('span', [_vm._v(_vm._s(item.stauts == "VERIFIED" ? new Date(item.validateTime).Format("yyyy/MM/dd hh:mm:ss") : "--"))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "8%"
      }
    }, [(item.id && item.stauts == 'NORMAL') ? _c('span', {
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.stopItem(item)
        }
      }
    }, [_vm._v("作废")]) : _vm._e(), _vm._v(" "), (item.id && item.stauts != 'NORMAL') ? _c('span', [_vm._v("---")]) : _vm._e()])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "prev, pager, next, jumper",
      "total": _vm.totalElements
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("抵用商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("会员名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("会员号码")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("派发员工")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("派发时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("到期时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("状态")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("核销时间")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-d62324b2","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/coupon/couponProfile.vue
// module id = 984
// module chunks = 1